
import AppRoutes from "./routes";
import WhatsAppButton from "./components/WhatsAppButton";

function App() {
  return (
    <><WhatsAppButton />
    <AppRoutes />
</>
      
      
    
  );
}

export default App;
